<template>
  <div>
    <div v-if="tipovista === 0">
      <v-list-item
        two-line
        v-for="(item0, i) in fichaEncab2"
        :key="i"
      >
        <v-list-item-content>
          <v-system-bar color="primary" dark>
            <v-spacer></v-spacer>
            <span class="font-weight-bold text-uppercase">
              {{ item0.Descripcion }}
            </span>
            <v-spacer></v-spacer>
          </v-system-bar>

          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr v-for="(item1, j) in fichaContenido(item0.Grupo)" :key="j">
                  <td class="caption font-weight-bold">
                    {{ item1.Descripcion }}
                  </td>
                  <td
                    class="font-weight-bold caption text-right"
                    v-html="item1.Valor"
                  ></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-list-item-content>
      </v-list-item>
    </div>
    <div v-if="tipovista === 1">
      <v-expansion-panels mandatory tile accordion multiple focusable>
        <v-expansion-panel 
          v-for="(item0, i) in fichaEncab2" 
          :key="i"
        >
          <v-expansion-panel-header
            color="primary"
            class="white--text text-uppercase font-weight-bold"
            v-if="fichaEncab(i + 1) > 1"
          >
            {{ item0.Descripcion }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-responsive class="overflow-y-auto" width="650px">
              <v-simple-table dense>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item1, j) in fichaContenido(item0.Grupo)" :key="j">
                      <td class="font-weight-bold">
                        {{ item1.Descripcion }}
                      </td>
                      <td class="text-right">
                        {{ item1.Valor }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-responsive>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <div v-if="tipovista === 2">
      <v-card 
      class="justify-start" 
    
      flat>
        <v-list-item 
          two-line 
          v-for="(item0, i) in fichaEncab2" 
          :key="i"
        >
          <v-list-item-content>
            <v-list-item-title>
              <span 
              class="font-weight-bold text-uppercase">{{
                item0.Descripcion
              }}</span>
              </v-list-item-title>
            <v-list-item-subtitle>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(item1, j) in fichaContenido(item0.Grupo)" :key="j">
                      <td class="caption font-weight-bold">
                        {{ item1.Descripcion }}
                      </td>
                      <td
                        class="font-weight-bold caption text-right"
                        v-html="item1.Valor"
                      ></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Verficha",
  props: {
    datosTecnicos: Array,
    tipovista: Number,
  },
  methods: {

  },
  computed: {
    fichaContenido: function () {
      return function (id) {
        return this.datosTecnicos.filter(
          (x) => x.Grupo === id && x.Valor != ""
        );
      };
    },
    fichaEncab: function () {
      return function (id) {
        let cont = 0;
        if (this.datosTecnicos != null) {
          this.datosTecnicos.forEach((e) => {
            if (e.Grupo === id) cont++;
          });
          return cont;
        }
      };
    },
    fichaEncab2() {
      if (this.datosTecnicos) {
        return this.datosTecnicos.filter((x) => x.Codigo === 0)
      }
      return true;
    },
  },
};
</script>

<style>
</style>